import React from 'react';
import { useTranslations } from '@montana/containers/translations';

export const ConfirmationSteps = () => {
    
    const translate = useTranslations();

    const steps = [
        translate(t => t.checkoutPage.confirmationPageStep1, '[We are going to quality check your order.]'),
        translate(t => t.checkoutPage.confirmationPageStep2, '[You will get a confirmation mail about your order within 1 week.]'),
        translate(t => t.checkoutPage.confirmationPageStep3, '[If you have any questions or concerns we would love to hear from you. We are present both on Phone and Mail.]'),
        translate(t => t.checkoutPage.confirmationPageStep4, '[We will put your order into production within 2 weeks.]'),
        translate(t => t.checkoutPage.confirmationPageStep5, '[Within 5 weeks you will be enjoying your new Montana furniture.]')
    ];

    return (
        <div>
            {steps.map((step, index) =>
                <div className="confirmation-step" key={index}>
                    <span className="confirmation-step__count">{index + 1}</span>
                    <span>{step}</span>
                </div>
            )}
        </div>
    )
};
